import { AfterContentChecked, ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Utility } from '../../../shared/utility/utility';
import { CashierService } from '../../services/cashier.service';
import { UserDetailsService } from '../../../services/user-details.service';
import { PAYMENT_METHODS, CASHIER_TYPES, britePlayScript, CASHIER_PAGES, DEPOSIT_TYPE_I_FRAME, TIME_DELAY_FOR_DEPOSIT_NOTIFICATION } from '../../config/cashier.config';
import { EmitterService } from '../../../services/emitter.service';
import { CustomAmountComponent } from '../custom-amount/custom-amount.component';
import { PaymentAjaxService } from '../../../payment-system/services/payment-ajax.service';
import { language } from '../../../shared/utility/config';
import { BritePlayService } from '../../services/brite-play.service';
import { AjaxService } from '../../../services/ajax.service';
import { CreditCardService } from '../../services/credit-card.service';
import { CashierCommonService } from '../../services/cashier.common.service';
import { IFrameService } from '../../services/i-frame.service';
import { MessageService } from '../../services/message.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { environment } from '../../../../environments/environment';
@Component({
  selector: "app-custom-cashier",
  templateUrl: "./custom-cashier.component.html",
  styleUrls: ["./custom-cashier.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CustomCashierComponent implements OnInit, AfterContentChecked,OnDestroy {
  userDetails;
  userCurrency;
  cashierMethodsObject;
  selectedPaymentMethod;
  selectedAmount;
  isFormValid = false;
  formDetails;
  errorMessage;
  isShowAbortPage = false;
  selectedPaymentMethodName = "";
  isFormValidationRequired = false;
  langCode;
  transactionMessage;
  isUserLoggedIn = false;
  currentScreenName = "";
  previousScreenName = "";
  cashierTransactionType = "";
  showScrollBar = false;
  selectorData;
  isLoading = true;
  isAbortPage = false;
  totalAmount = 0;
  iFramePage = CASHIER_PAGES.I_FRAME_PAGE;
  transactionStatusPage = CASHIER_PAGES.TRANSACTION_STATUS_PAGE;
  paymentDetailsPage = CASHIER_PAGES.PAYEMENT_DETAILS_PAGE;
  destroy$: Subject<boolean> = new Subject<boolean>();
  isPlayUser = true;
  cashierBannerZoneId = environment.cashierBannerZoneId;

  @ViewChild(CustomAmountComponent)
  childCustomAmountComponent: CustomAmountComponent;

  @ViewChild("cashierContainer") cashierContainer: ElementRef<any>;

  //On window message transaction status
  @HostListener("window:message", ["$event"]) onMessage(e) {
    this.getTransactionDetails(e);
  }

  constructor(
    private utils: Utility,
    private cashierService: CashierService,
    private userDetailsService: UserDetailsService,
    private emitterService: EmitterService,
    private cdref: ChangeDetectorRef,
    private paymentService: PaymentAjaxService,
    private britePlayService: BritePlayService,
    private ajaxService: AjaxService,
    private creditCardService: CreditCardService,
    private cashierCommonService: CashierCommonService,
    private iFrameService:IFrameService  ) {
    this.emitterService.toggleCashierLoader$.pipe(takeUntil(this.destroy$)).subscribe((state) => {
      this.isLoading = state;
    });
    this.emitterService.updateCashierFormData$.pipe(takeUntil(this.destroy$)).subscribe((form) => {
      this.updateFormDetails(form)
    });
    this.emitterService.cashierModalState$.pipe(takeUntil(this.destroy$)).subscribe((status) => {
      if (status) {
        this.updateCashierMethodsData();
      }
    });
    this.emitterService.customCashierPage$.pipe(takeUntil(this.destroy$)).subscribe((state) => {
      this.currentScreenName = this.iFramePage;
    });
    this.emitterService.userDataSource$.pipe(takeUntil(this.destroy$)).subscribe((status) => {
      if (status == "User Data Updated") {
        this.updateCashierMethodsData();
      }
    });
    this.langCode = localStorage.getItem("langCode") ? localStorage.getItem("langCode") : "en";

    //on payment method change updating payment method
     
    this.emitterService.onChangePaymentMethod$.pipe(takeUntil(this.destroy$)).subscribe((newMethod) => {
      this.updateSelectedPaymentMethod(newMethod);
      this.clearMessage();
    });

    this.emitterService.customerCashierTransactionStatusChange$.pipe(takeUntil(this.destroy$)).subscribe(
      (redirectionDetails: any) => {
        this.isLoading = redirectionDetails.isLoading;
        this.changeCurrentPage(redirectionDetails.page);
        this.transactionMessage = redirectionDetails.message;
        this.updateCashierMethodsData("status");
      }
    );

    //After payment method change, checking form is required or not
    this.emitterService.isFormValidationEnabled$.pipe(takeUntil(this.destroy$)).subscribe((status) => {
      this.isFormValidationRequired = status;
    });

  }

  ngOnInit(): void {
    this.isUserLoggedIn = this.utils.isUserLoggedIn();
    this.cashierTransactionType = this.cashierTransactionType ? this.cashierTransactionType : "DEPOSIT";
    setTimeout(() => {
      this.checkScrollForCashierContainer();
    }, 1000);
  }

  ngAfterContentChecked(): void {
    this.cdref.detectChanges();
    if (this.cashierContainer.nativeElement.scrollTop + this.cashierContainer.nativeElement.offsetHeight 
         >
       this.cashierContainer.nativeElement.scrollHeight - 50) {
        this.showScrollBar = false;
     }
    if (this.cashierContainer.nativeElement.scrollTop < 20 && this.cashierContainer.nativeElement.scrollHeight
        >
        this.cashierContainer.nativeElement.offsetHeight + 50
    ) {
      this.showScrollBar = true;
    }
  }

  /* Abort page toggler*/
  showAbortPage(state) {
    this.isAbortPage = state;
  }

  /* Scroll bottom */
  scrollBottom() {
    this.showScrollBar = false;
    this.cashierContainer.nativeElement.scrollTop = this.cashierContainer.nativeElement.scrollHeight;
  }
  /* On page load checking scroll height */
  checkScrollForCashierContainer() {
    if ( this.cashierContainer.nativeElement.scrollHeight > this.cashierContainer.nativeElement.offsetHeight + 50) {
      this.showScrollBar = true;
    }
  }
checkCashierBanner(){
  if(!this.userDetails?.userProfileDetails){
    this.userDetails = this.userDetailsService.userProfileDetails;
  }
  if(this.userDetails && this.userDetailsService?.userProfileDetails?.userStatus != 'real' && !this.userDetails.balanceDetails.cash){
    this.isPlayUser = true;
  }else{
    this.isPlayUser = false;
  }
}

  /*Selected payment method name*/ 
  getSelectedPaymentMethodName(){
    let selectedPaymentName = this.selectedPaymentMethodName
    if(selectedPaymentName){
      if(selectedPaymentName.includes("-")){
        selectedPaymentName = selectedPaymentName.split('-')[0].toLowerCase()
      }
    }
    return selectedPaymentName ? "custom-payment-"+selectedPaymentName.toLowerCase() : ""
  }

  updateCashierMethodsData(isStatus = "") {
    let customMethods = this.cashierService.customMethodsList;
    if (customMethods && customMethods.length) {
      let piqMethods = this.cashierService.piqMethodsList;
     this.checkCashierBanner();
      this.updateDataForMethods([customMethods, piqMethods], isStatus);
    } else {
      if (this.isUserLoggedIn) {
       this.updateAllPaymentMethods(isStatus);
      } else {
        this.cashierService
          .getPnpCashierConfigData(CASHIER_TYPES.TRANSACTION_DEPOSIT)
          .pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.updateDataForMethods(res, isStatus);
          });
      }
    }
  }
  updateAllPaymentMethods(isStatus){
    this.userDetails = this.userDetailsService.userProfileDetails;
    this.userCurrency = this.userDetailsService.getUserCurrencyForCahier();
    if (this.userDetails) {
      this.cashierService.getCashierDetails(this.userDetails,CASHIER_TYPES.TRANSACTION_DEPOSIT).subscribe((res) => {
          this.updateDataForMethods(res, isStatus);
        });
    }
  }

  updateDataForMethods(data, isStatus) {
    if (data) {
      this.cashierMethodsObject = this.cashierService.getCashierMethodsObject(data);
    }
    this.selectorData = this.cashierMethodsObject;
    let isStatusLoading = localStorage.getItem('transactionStatusIsLoading');

    if (this.isUserLoggedIn && !isStatus && !isStatusLoading) {
      this.isLoading = false;
    }
  }

  abortScreen(state) {
    this.isShowAbortPage = state;
  }

  closeDepositModal() {
    this.isLoading = true;
    this.isAbortPage = false;
    this.currentScreenName = "";
    this.closeModal();
  }
  closeModal() {
    this.emitterService.broadCastCashierModalState(false);
    this.utils.closeModal("custom_cashier_modal");
  }

  //payment method change detector
  updateSelectedPaymentMethod(data) {
    this.selectedPaymentMethod = data;
    this.selectedPaymentMethodName = data.name;
    this.updateTransactionBreakDownComponent();
    this.changeCurrentPage(this.paymentDetailsPage);
    if (data.maxAmount) {
      this.childCustomAmountComponent.minLimit = parseFloat(data.minAmount);
      this.childCustomAmountComponent.maxLimit = parseFloat(data.maxAmount);
    }
  }

  //amount change detector
  updateAmountSelection(val) {
    if (this.cashierService.isQuickDepositClicked && this.cashierService.quickDepositSelectionAmount) {
      this.selectedAmount = val;
      this.updateTransactionBreakDownComponent();
      this.cashierService.quickDepositSelectionAmount = 0;
      this.cashierService.isQuickDepositClicked = false;
      this.isLoading = true;
      this.getBriteplayPaymentRequestObject(this.cashierTransactionType);
    } else {
      this.selectedAmount = val;
      this.updateTransactionBreakDownComponent();
    }
  }

  updateTransactionBreakDownComponent() {
    this.emitterService.broadCastAmountInTransactionBreakdown({
      method: this.selectedPaymentMethod,
      amount: this.selectedAmount,
    });
  }
  updateFormDetails(e) {
    this.formDetails = e;
    this.isFormValid = e.valid ? false : true;
  }
  processCall() {
    if(this.checkIsInValidAmount()){
      return;
    }
    this.transactionMessage = "";
    if (this.isUserLoggedIn) {
      if (this.isFormValidationRequired) {
        this.utils.validateAllFormFields(this.formDetails);
        this.emitterService.broadCastSubmitFormClick(true);
      }

      if (this.formDetails?.valid || !this.isFormValidationRequired) {
        let requestObj: any = "";
        this.isLoading = true;

        if (this.selectedPaymentMethodName.includes(PAYMENT_METHODS.CREDITCARD) || this.selectedPaymentMethodName.includes(PAYMENT_METHODS.MIFINITY )) {
             requestObj = this.getCreditCardRequestObject();
             this.processApiCall(requestObj);
        } else if (this.selectedPaymentMethodName.includes(PAYMENT_METHODS.BRITEPLAY)) {
             requestObj = this.getBriteplayPaymentRequestObject(
             this.cashierTransactionType
          );
        } else if (this.selectedPaymentMethodName.includes(PAYMENT_METHODS.PLIXPAY) || this.selectedPaymentMethodName.includes(PAYMENT_METHODS.ARI_10)) {

          let data = {
            depositAmount: this.selectedAmount,
            txnType: DEPOSIT_TYPE_I_FRAME,
            paymentMethod: this.selectedPaymentMethodName,
          };
          this.iFrameService.makePaymentMethodTransaction(data);
        } 
      } else {
        this.utils.validateAllFormFields(this.formDetails);
      }
    } else {
      this.isLoading = true;
      this.getBriteplayPaymentRequestObject(this.cashierTransactionType);
    }
  }

  processApiCall(requestObj) {
    let locale = language[this.langCode];
    this.paymentService.makePaymentPaymentIQ(requestObj, locale).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        this.isLoading = false;
        this.transactionMessage = "";
        if (!res["success"] && res["txState"] == "FAILED" && res["errors"] && res["errors"].length) {
          this.transactionMessage = res["errors"][0].msg;
        } else if (res["success"] && res["txState"] == "SUCCESSFUL") {
          this.creditCardWithoutRedirection(res)
        //  this.messageService.successTransactionMessage({txnAmount:this.selectedAmount, amount:this.selectedAmount});
        
        } else if (res["txState"] == "WAITING_INPUT" && res.redirectOutput && res.redirectOutput["container"] == "iframe") {
          this.cashierCommonService.generateIframe(res.redirectOutput["url"], false);
          localStorage.setItem("txnIdCc", res["txId"]);
        }
      });
  }

  creditCardWithoutRedirection(txnDetails){
    let data = {
      playerId: this.userDetailsService?.userProfileDetails?.playerID,
      token: this.cashierService?.tokenData.token,
      event: null,
      currencySymbol: this.userDetailsService.getUserCurrencySymbol(),
      selectedAmount:this.selectedAmount,
      txnId:txnDetails?.txId
    };
    this.creditCardService.getTransactionDetails(data);
  }
  getCreditCardRequestObject() {
    let requestInfo = {
      formDetails: this.formDetails,
      selectedPaymentMethod: this.selectedPaymentMethod,
      amount: this.selectedAmount,
      playerID: this.userDetailsService.userProfileDetails.playerID,
    };
    return this.creditCardService.getCreditCardRequestObject(requestInfo);
  }

  async getBriteplayPaymentRequestObject(transactionTYpe) {
    let initData = {
      transactionAmount: this.selectedAmount,
      txnType: transactionTYpe,
    };
    let requestObj = this.cashierCommonService.getBriteplayRequestObj(initData);
    let briteResponse = await this.ajaxService.britePayAndPlayInit(requestObj);
    if (briteResponse["status"] === "SUCCESS" && briteResponse["signature"]) {
      localStorage.setItem("txnId", briteResponse["txnId"]);
      this.britePlayService.loadBriteScript(
        britePlayScript,
        briteResponse["signature"]
      );
    } else if (briteResponse["status"] === "FAILURE") {
      this.isLoading = false;
      this.transactionMessage = briteResponse["errorDescription"];
      this.ngOnInit();
    }
    return requestObj;
  }

 
 
  checkIsInValidAmount() {
    let minAmount = this.selectedPaymentMethod?.minAmount ? this.selectedPaymentMethod?.minAmount : 0;
    minAmount = parseFloat(minAmount);

    let currentAmount = this.selectedAmount ? this.selectedAmount : 0;
    currentAmount = parseFloat(currentAmount);

    if (this.selectedPaymentMethod && this.selectedPaymentMethod.name) {
      if (currentAmount && currentAmount >= minAmount) {
        return false;
      }
    }
    return true;
  }
  clearMessage() {
    this.transactionMessage = "";
  }
  getTransactionDetails(e) {
    this.userDetails = this.userDetailsService?.userProfileDetails;
    if (e.data?.message?.paymentMethod == this.selectedPaymentMethod?.name) {
      let data = {
        playerId: this.userDetails?.playerID,
        token: this.cashierService?.tokenData.token,
        event: e,
        currencySymbol: this.userDetailsService.getUserCurrencySymbol(),
        selectedAmount:this.selectedAmount
      };
      this.creditCardService.getTransactionDetails(data);
    } else {
      this.iFrameService.updateTransactionDetails(e);
    }
  }
  changeCurrentPage(page, previusPage=false){
   if(!this.isLoading){
    if(previusPage){
      this.currentScreenName =  this.previousScreenName;
    }else{
      this.currentScreenName = page;
      this.previousScreenName = this.previousScreenName != this.currentScreenName  && this.previousScreenName? this.previousScreenName : page;
    }
   }
    
  }
 backButton(){
  this.changeCurrentPage(this.paymentDetailsPage);
  this.isLoading = true;
  this.updateCashierMethodsData();
 }
ngOnDestroy(): void {
  this.destroy$.next(true);
  this.destroy$.unsubscribe();
}
 
}
